import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { UserChangePasswordDTO, UserDTO } from "../auth/User";

const PATH = "users";

@Injectable({
  providedIn: "root",
})
export class UsersHandlerService {
  constructor(private apiService: ApiService) {}

  usersGet(
    masterAccountID: number,
    queryParams?: {
      page?: number;
      perPage?: number;
      ignoreSuper?: boolean;
      unassigned?: boolean;
    },
  ) {
    return this.apiService.get(`${PATH}/${masterAccountID}`, {
      params: queryParams,
    });
  }

  userGet(masterAccountID: number, userID: number) {
    return this.apiService.get(`${PATH}/${masterAccountID}/${userID}`);
  }

  userPut(masterAccountID: number, userDTO: UserDTO) {
    return this.apiService.put(
      `${PATH}/${masterAccountID}/${userDTO.id}`,
      userDTO,
    );
  }

  userPost(masterAccountID: number, userDTO: UserDTO) {
    return this.apiService.post(`${PATH}/${masterAccountID}`, userDTO);
  }

  userDelete(masterAccountID: number, userDTO: UserDTO) {
    return this.apiService.delete(`${PATH}/${masterAccountID}/${userDTO.id}`);
  }

  activateUser(masterAccountID: number, userID: number) {
    return this.apiService.put(`${PATH}/${masterAccountID}/${userID}/activate`, {});
  }

  changePassword(
    masterAccountID: number,
    userChangePasswordDTO: UserChangePasswordDTO,
    userDTO: UserDTO,
  ) {
    return this.apiService.post(
      `${PATH}/${masterAccountID}/${userDTO.id}/changePassword`,
      userChangePasswordDTO,
    );
  }
}
